import orderCustomForm from '@/api/order_custom_form'

export default ({ commit }, param) => {
  return new Promise((resolve, reject) => {
    orderCustomForm.getOptionOrderCustomFormField(result => {
      resolve(result.data.data)
    }, param)
  })
}



// WEBPACK FOOTER //
// ./src/store/modules/order_custom_form/actions/getOptionOrderCustomFormField.js